import api from '../index'

export interface Package {
  id: number
  name: string
  price: number | string
  duration: number
  description?: string
  level?: number
  initial_user_count?: number
  extra_user_price?: string
  ai_monthly_credits?: string
  modules_count?: number
  sort?: number
  status: 0 | 1
  created_at: string
  updated_at: string
}

export interface PackageListParams {
  page?: number
  pageSize?: number
  keyword?: string
  status?: 0 | 1
}

export interface PackageGiftData {
  user_team_id: number
  package_id: number
  remark?: string
}

export interface PackageGiftListParams {
  user_team_id?: number
  package_id?: number
  operator_admin_id?: number
  request_no?: string
  page?: number
  pageSize?: number
}

export interface PackageGiftRecord {
  id: number
  user_team_id: number
  package_id: number
  operator_admin_id: number
  request_no: string
  remark?: string
  start_time?: string
  expire_time?: string
  max_user_count?: number
  status: 1 | 2
  created_at?: string
  updated_at?: string
  package?: Pick<Package, 'id' | 'name' | 'duration' | 'initial_user_count'>
  operator_admin?: {
    id: number
    username: string
    name: string
  }
  user_team?: {
    id: number
    name: string
    code: string
  }
}

export default {
  // 获取套餐卡列表
  list: (params?: PackageListParams) => api.get('package/list', { params }),

  // 添加套餐卡
  add: (data: any) => api.post('package/add', data),

  // 获取套餐卡详情
  show: (id: number) => api.get(`package/show/${id}`),

  // 更新套餐卡
  update: (id: number, data: any) => api.put(`package/update/${id}`, data),

  // 删除套餐卡
  delete: (id: number) => api.delete(`package/delete/${id}`),

  // 赠送套餐
  gift: (data: PackageGiftData) => api.post('package/gift', data),

  // 获取赠送记录
  giftList: (params?: PackageGiftListParams) => api.get('package/gift/list', { params }),
}
